import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { moneyTransFerType } from "../../../../utilities/const";

// img

const SendMoneyCard = ({ type, banks }) => {
  const [selectedBank, setSelectedBank] = useState();
  const [amount, setAmount] = useState("");

  const sendMoneyHandler = () => {
    if (type === moneyTransFerType.walletToBank) {
    }
    if (type === moneyTransFerType.BankToWallet) {
    }
  };

  return (
    <Form>
      <div className="py-2">
        <label
          htmlFor=""
          className="form-label text-danger d-block text-center m-0 fw-sbold"
        >
          Send Money
        </label>
        <input
          type="number"
          className="form-control"
          onClick={(e) => setAmount(e.target.value)}
        />
      </div>
      <div className="py-2">
        <label
          htmlFor=""
          className="form-label text-danger d-block text-center m-0 fw-sbold"
        >
          Choose Bank
        </label>
        <ul className="list-unstyled ps-0 mb-0">
          {banks?.map((bank, key) => {
            return (
              <li className="my-1 d-flex align-items-start justify-content-between">
                <div className="left d-flex align-items-center gap-10">
                  <div className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="19"
                      viewBox="0 0 30 19"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_0_4175)">
                        <path
                          d="M11.0773 1.96484H19.0154V16.4089H11.0773V1.96484Z"
                          fill="#FF5F00"
                        />
                        <path
                          d="M11.5816 9.18704C11.5816 6.25234 12.9424 3.64929 15.034 1.96496C13.4969 0.740041 11.5565 0 9.43963 0C4.42454 0 0.36731 4.10859 0.36731 9.18704C0.36731 14.2654 4.42454 18.3741 9.43952 18.3741C11.5564 18.3741 13.4967 17.634 15.034 16.409C12.9424 14.7503 11.5816 12.1218 11.5816 9.18704Z"
                          fill="#EB001B"
                        />
                        <path
                          d="M29.7259 9.18692C29.7259 14.2653 25.6686 18.374 20.6537 18.374C18.5368 18.374 16.5964 17.6339 15.0592 16.4089C17.176 14.7247 18.5117 12.1216 18.5117 9.18692C18.5117 6.25222 17.1508 3.64917 15.0592 1.96484C16.5963 0.739919 18.5368 -0.00012207 20.6537 -0.00012207C25.6686 -0.00012207 29.726 4.13404 29.726 9.18692H29.7259Z"
                          fill="#F79E1B"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_0_4175">
                          <rect
                            width="29.3878"
                            height="18.3673"
                            fill="white"
                            transform="translate(0.36731)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <p className="m-0 text-muted fw-sbold">
                  {bank.bankName} **** **** **** {bank.accountNumber}
                  </p>
                </div>
                <div className="right">
                  <input name="bank" type="radio" className="rounded-circle" />
                </div>
              </li>
            );
          })}
          {/* <li className="my-1 d-flex align-items-start justify-content-between">
            <div className="left d-flex align-items-start gap-10">
              <div className="icn me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="10"
                  viewBox="0 0 30 10"
                  fill="none"
                >
                  <g clip-path="url(#clip0_0_4195)">
                    <path
                      d="M15.1985 3.45355C15.1818 4.77554 16.3767 5.51321 17.2768 5.95185C18.2016 6.40185 18.5122 6.69045 18.5085 7.09292C18.5016 7.7088 17.7709 7.98064 17.087 7.9912C15.8939 8.00968 15.2002 7.66908 14.6488 7.41148L14.219 9.42259C14.7723 9.67755 15.7968 9.89991 16.8593 9.90967C19.3532 9.90967 20.9848 8.6786 20.9936 6.76988C21.0034 4.34746 17.643 4.21338 17.6659 3.13062C17.6739 2.80231 17.9871 2.45195 18.6736 2.36287C19.0134 2.31787 19.9514 2.28343 21.0149 2.77315L21.4323 0.827359C20.8604 0.61912 20.1253 0.419719 19.2102 0.419719C16.8628 0.419719 15.2118 1.66755 15.1985 3.45355ZM25.443 0.58732C24.9876 0.58732 24.6039 0.852958 24.4326 1.2606L20.8701 9.76675H23.3622L23.8581 8.3962H26.9034L27.1911 9.76675H29.3876L27.4709 0.58732H25.443ZM25.7917 3.06703L26.5108 6.514H24.5412L25.7917 3.06703ZM12.177 0.587436L10.2126 9.76663H12.5874L14.5508 0.587206H12.177M8.66387 0.587206L6.19208 6.8352L5.19221 1.52279C5.07489 0.929757 4.61157 0.58732 4.09706 0.58732H0.0564723L-0.00012207 0.853876C0.829393 1.03388 1.77187 1.3242 2.34286 1.63483C2.6923 1.82459 2.79194 1.99047 2.90674 2.44139L4.80053 9.76675H7.31008L11.1576 0.58732H8.66387"
                      fill="url(#paint0_linear_0_4195)"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_0_4195"
                      x1="13.5106"
                      y1="10.1"
                      x2="13.7853"
                      y2="0.353719"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#222357" />
                      <stop offset="1" stop-color="#254AA5" />
                    </linearGradient>
                    <clipPath id="clip0_0_4195">
                      <rect
                        width="29.3878"
                        height="9.52806"
                        fill="white"
                        transform="translate(0 0.419678)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p className="m-0 text-muted fw-sbold">
                HDFC Bank **** **** **** 8395
              </p>
            </div>
            <div className="right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
              >
                <path
                  d="M9.97957 1.14795C8.39025 1.14795 6.83663 1.61924 5.51516 2.50221C4.1937 3.38519 3.16374 4.64019 2.55553 6.10853C1.94733 7.57686 1.7882 9.19258 2.09826 10.7514C2.40832 12.3101 3.17364 13.742 4.29746 14.8658C5.42127 15.9896 6.8531 16.7549 8.41188 17.065C9.97065 17.375 11.5864 17.2159 13.0547 16.6077C14.523 15.9995 15.778 14.9695 16.661 13.6481C17.544 12.3266 18.0153 10.773 18.0153 9.18366C18.0153 7.05246 17.1687 5.00854 15.6617 3.50156C14.1547 1.99457 12.1108 1.14795 9.97957 1.14795ZM9.97957 16.0714C8.6173 16.0714 7.28562 15.6675 6.15293 14.9106C5.02025 14.1538 4.13743 13.0781 3.61611 11.8195C3.09479 10.5609 2.95839 9.17602 3.22416 7.83993C3.48992 6.50384 4.14592 5.27656 5.10919 4.31329C6.07246 3.35002 7.29974 2.69402 8.63583 2.42825C9.97193 2.16249 11.3568 2.29889 12.6154 2.82021C13.874 3.34153 14.9497 4.22435 15.7065 5.35703C16.4634 6.48972 16.8673 7.82139 16.8673 9.18366C16.8673 11.0104 16.1416 12.7623 14.8499 14.054C13.5582 15.3457 11.8063 16.0714 9.97957 16.0714Z"
                  fill="#027FEE"
                />
              </svg>
            </div>
          </li> */}
        </ul>
      </div>
      <div className="py-2 text-center">
        <Button className="d-inline-flex align-items-center justify-content-center commonBtn">
          Send Money
        </Button>
      </div>
    </Form>
  );
};

export default SendMoneyCard;
